// Single source of truth for the backend origin.
// Set REACT_APP_API_URL in .env to switch between local and production.
// REACT_APP_API_URL=/ means "same origin": API calls go to whichever server
// serves the page — use it for the build copied into the backend's build/.
// Note: Create React App only exposes env vars prefixed with REACT_APP_.
const API_BASE_URL = (
  process.env.REACT_APP_API_URL || "https://siteregistration.inframantra.com"
).replace(/\/$/, "");

export default API_BASE_URL;
